import {getRegistrationErrorDataMessage} from '../../consts/analytics/registrationErrorsData';
import * as iccResponseErrorTypes from '../../consts/icc/iccResponseErrorTypes';
import ICC_PRODUCT_STATUS_TYPES from '../../enums/icc/iccProductStatusTypes';

const getFailedProductRegistrationErrorMessage = (error) => {
    try {
        if (error === ICC_PRODUCT_STATUS_TYPES.FAILED) {
            return 'Unknown Error';
        }

        if (iccResponseErrorTypes.isRegistrationFailedIccHttpError(error?.errorCode)) {
            const {errorCode, errorMessage} = iccResponseErrorTypes.getRegistrationFailedError(error.errorCode);

            return `Error code ${errorCode}: ${errorMessage}`;
        }

        return getRegistrationErrorDataMessage(error);
    } catch (e) {
        return 'Unknown Error';
    }
};

export default {
    getFailedProductRegistrationErrorMessage,
};
